// app fonts
const flameBold = require('../assets/fonts/flame-bold.ttf');
const flameRegular = require('../assets/fonts/flame-regular.ttf');
const flameSansRegular = require('../assets/fonts/flame-sans-regular.ttf');

export default [
  {
    flameBold,
    flameRegular,
    flameSansRegular
  }
];
